import ReducerRegistry from '../base/redux/ReducerRegistry';
import { REMOVE_SECOND_SCREEN, RESET_SECOND_SCREENS, SET_SECOND_SCREEN, SET_SECOND_SCREEN_WINDOW } from './actionTypes';
const DEFAULT_STATE = {
    screens: {}
};
ReducerRegistry.register('features/multi-screen', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_SECOND_SCREEN:
            // Merge so a re-configuration of an existing window keeps its live handle.
            return {
                ...state,
                screens: {
                    ...state.screens,
                    [action.id]: {
                        ...state.screens[action.id],
                        source: action.source,
                        screenId: action.screenId
                    }
                }
            };
        case SET_SECOND_SCREEN_WINDOW: {
            const entry = state.screens[action.id];
            if (!entry) {
                return state;
            }
            return {
                ...state,
                screens: {
                    ...state.screens,
                    [action.id]: { ...entry, handle: action.handle }
                }
            };
        }
        case REMOVE_SECOND_SCREEN: {
            const screens = { ...state.screens };
            delete screens[action.id];
            return { ...state, screens };
        }
        case RESET_SECOND_SCREENS:
            return { ...state, screens: {} };
    }
    return state;
});
